import RiskFeedView from './RiskFeedView';
export default { RiskFeedView };
